import {eventerConsoleApiClient} from "../../../../api-client/EventerConsoleApiClient.ts";
import {useAccount} from "../Accounts.tsx";
import {ListItem, ListItemIcon, ListItemText, Typography} from "@mui/material";
import {useCallback} from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FullSizeBox from "../../../../../appfw/ui/components/FullSizeBox.tsx";
import DialogActionButton from "../../../../../appfw/ui/dialogs/DialogActionButton.tsx";
import {useBrandingTitleSuffix} from "../../../../../appfw/ui/branding/BrandingControl.tsx";

export default function SettingsPage() {

    const account = useAccount()

    const onDeleteAccountClick = useCallback(async () => {
        let accountId = account.id
        if (accountId) {
            await eventerConsoleApiClient.deleteAccount({accountId: accountId})

            // Account has been deleted => full reload
            window.location.replace("/")
        }
    }, [account])

    useBrandingTitleSuffix("Account")

    return (
        <FullSizeBox>
            <DialogActionButton
                dialogTitle={`Account '${account.podName}' wirklich löschen?`}
                dialogContent={"Alle Daten werden unwiderruflich gelöscht!"}
                disabled={account.role != "owner"}
                outlet={
                    <ListItem>
                        <ListItemIcon
                            sx={{minWidth: `32px`}}
                        >
                            <DeleteForeverIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Pod löschen"/>
                    </ListItem>
                }
                dialogActions={[
                    {
                        label: "Abbrechen",
                    },
                    {
                        label: "Löschen",
                        action: onDeleteAccountClick,
                    }
                ]}
            />

            <Typography mt="auto" color="text.secondary" variant="body2" sx={{marginBottom: 2}}>
                Version: {__APP_VERSION__}
            </Typography>
        </FullSizeBox>
    )
}
